export const equipmentStatusOptions = [
  { label: 'Ativo', value: 'enabled' },
  { label: 'Inativo', value: 'disabled' },
];
